/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTransactionsStats200Response
 */
export interface GetTransactionsStats200Response {
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsStats200Response
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsStats200Response
     */
    receivedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsStats200Response
     */
    refundedAmount: number;
}

/**
 * Check if a given object implements the GetTransactionsStats200Response interface.
 */
export function instanceOfGetTransactionsStats200Response(value: object): value is GetTransactionsStats200Response {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('receivedAmount' in value) || value['receivedAmount'] === undefined) return false;
    if (!('refundedAmount' in value) || value['refundedAmount'] === undefined) return false;
    return true;
}

export function GetTransactionsStats200ResponseFromJSON(json: any): GetTransactionsStats200Response {
    return GetTransactionsStats200ResponseFromJSONTyped(json, false);
}

export function GetTransactionsStats200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTransactionsStats200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'receivedAmount': json['receivedAmount'],
        'refundedAmount': json['refundedAmount'],
    };
}

export function GetTransactionsStats200ResponseToJSON(json: any): GetTransactionsStats200Response {
    return GetTransactionsStats200ResponseToJSONTyped(json, false);
}

export function GetTransactionsStats200ResponseToJSONTyped(value?: GetTransactionsStats200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'receivedAmount': value['receivedAmount'],
        'refundedAmount': value['refundedAmount'],
    };
}

